var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.coords.length !== 0)?_c('yandex-map',{staticStyle:{"width":"100%","height":"600px"},attrs:{"coords":_vm.coords,"zoom":"9","use-object-manager":""},on:{"map-was-initialized":_vm.initHandler}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }